import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { delay, Observable, of, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { LanguageService } from '@fcom/ui-translate';
import { CmsTemplateService } from '@fcom/cms/services';
import { CmsTemplate } from '@fcom/core-api';
import { Profile } from '@fcom/core-api/login';
import { LoyaltyRoutesPath } from '@fcom/loyalty-core/interfaces';
import { MediaQueryService, PageMetaService, ScrollService } from '@fcom/common/services';
import { unsubscribe } from '@fcom/core/utils';
import { setPageMetadata } from '@fcom/loyalty-core';
import { profile } from '@fcom/core/selectors';
import { AppState } from '@fcom/core';
import { TabTheme } from '@fcom/ui-components';

@Component({
  selector: 'fin-balance-and-transactions',
  templateUrl: 'balance-and-transactions.component.html',
  styleUrls: ['../../../loyalty-core/assets/styles/common.scss', './balance-and-transactions.component.scss'],
})
export class BalanceAndTransactionsComponent implements OnInit, OnDestroy, AfterViewInit {
  public readonly SvgLibraryIcon = SvgLibraryIcon;
  public readonly TabTheme = TabTheme;

  isMobile$: Observable<boolean>;
  template$: Observable<CmsTemplate>;
  pageTitle$: Observable<string>;

  profile$: Observable<Profile>;
  pageViewType$: Observable<string> = of('');
  showSideTitle$: Observable<boolean> = of(false);
  displayCreditCardBanner$: Observable<boolean>;

  awardAndTierPointsExpandOpen = false;

  private subscriptions: Subscription = new Subscription();

  @ViewChild('usePointsContent')
  usePointsContent: ElementRef<HTMLElement>;

  constructor(
    private cmsTemplateService: CmsTemplateService,
    private languageService: LanguageService,
    private pageMetaService: PageMetaService,
    private store$: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private mediaQueryService: MediaQueryService,
    private scrollService: ScrollService
  ) {}

  ngOnInit(): void {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');

    this.template$ = this.cmsTemplateService.load(
      `/${this.languageService.langValue}/${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.BALANCE_AND_TRANSACTIONS}`
    );
    this.pageTitle$ = this.template$.pipe(map((template: CmsTemplate) => template?.header?.[0]?.title ?? ''));

    this.profile$ = this.store$.pipe(profile(), take(1));
  }

  scrollToPoints(): void {
    this.scrollService.smoothScroll(this.usePointsContent);
    this.usePointsContent.nativeElement.focus();
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.template$.subscribe((template: CmsTemplate) => setPageMetadata(template, this.pageMetaService))
    );

    this.subscriptions.add(
      this.activatedRoute.fragment
        .pipe(
          filter((fragment) => fragment === 'usePoints'),
          delay(0)
        )
        .subscribe(() => this.scrollToPoints())
    );
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
